export default "__VITE_ASSET__4be9831a__"